export interface CBPatient {
  firstName: string;
  lastName: string;
  age: number;
  weight: number;
  height: number;
  gender: string;
  pregnancy: boolean;
  weeksOfPregnancy: number;
  breastfeeding: boolean;
  ammPathologies: PatientPathology[];
  allergies: PatientAllergy[];
  medicalTeam: PatientMedicalTeam;
  hepaticStage: string;
  creatinineClearance: number;
  molCreatinine: number;
  mglCreatinine: number;
  gfr: number;
}

export interface PatientPathology {
  type: string;
  code: string;
  label: string;
}

export interface PatientAllergy {
  code: number;
  label: string;
}

export interface PatientMedicalTeam {
  firstNameDoctor: string;
  lastNameDoctor: string;
  firstNameSpecialist: string;
  lastNameSpecialist: string;
  firstNamePharmacist: string;
  lastNamePharmacist: string;
  firstNameNurse: string;
  lastNameNurse: string;
}
